<template>
    <header class="main-header" :class="{'transparent-header' : isLoginRegisterView}">
        <div class="header-left">
            <router-link :to="{name: 'palettes'}">
                <div class="logo-mark-container">
                    <logo-mark />
                </div>
                <div class="logo-text-container">
                    <logo-text :fill="activeSwatchColor" />
                </div>
            </router-link>
        </div>
        <div class="header-right" v-if="!isLoginRegisterView">
            <user-header></user-header>
        </div>
    </header>
</template>

<script>
    import LogoMark      from "../../../../Lib/Icons/LogoMark";
    import LogoText      from "../../../../Lib/Icons/LogoText";
    import UserHeader    from "../../../../Domain/User/Views/Components/UserHeader";
    import { rgbCSS }    from "../../../../Lib/helpers/cssOutput";
    import ActivePalette from "../../../../Domain/Palette/Store/ActivePalette";

    export default {
        name      : "main-header",
        components: {
            UserHeader,
            LogoMark,
            LogoText,
        },

        data() {
            return {
               logoTextColor: '#006CE4',
            }
        },

        computed: {
            activeSwatchColor() {
                let swatch = new ActivePalette().getActiveSwatch();

                if(swatch === undefined) {
                    return this.logoTextColor;
                } else {
                    return rgbCSS(swatch.color);
                }
            },

            isLoginRegisterView() {
                return this.$route.name === 'login' || this.$route.name === 'register' || this.$route.name === 'reset-password';
            }
        },
    }
</script>
